export const MARKETPLACE_OPTIONS = [
  { value: "Amazon", label: "Amazon" },
  { value: "Flipkart", label: "Flipkart" },
  { value: "Nykaa", label: "Nykaa" },
  { value: "Blinkit", label: "Blinkit" },
  { value: "Zepto", label: "Zepto" },
  { value: "Swiggy Instamart", label: "Swiggy Instamart" },
  { value: "Other", label: "Other" },
];

export const COUNTRY_OPTIONS = [
  { value: "India", label: "India" },
  { value: "USA", label: "USA" },
  { value: "UAE", label: "UAE" },
  { value: "UK", label: "UK" },
  { value: "Singapore", label: "Singapore" },
  { value: "Other", label: "Other" },
];

export const FIELD_LABELS = [
  ["search_term", "Search Term", true],
  ["search_frequency_rank", "Search Frequency Rank"],
  ["category", "Category"],
  ["subcategory", "Subcategory"],
  ["top_clicked_brand_1", "Top Clicked Brand 1"],
  ["top_clicked_brand_2", "Top Clicked Brand 2"],
  ["top_clicked_brand_3", "Top Clicked Brand 3"],
  ["top_clicked_asin_1", "Top Clicked ASIN 1"],
  ["top_clicked_asin_2", "Top Clicked ASIN 2"],
  ["top_clicked_asin_3", "Top Clicked ASIN 3"],
  ["top_click_share_1", "Top Click Share 1"],
  ["top_click_share_2", "Top Click Share 2"],
  ["top_click_share_3", "Top Click Share 3"],
  ["top_conversion_share_1", "Top Conversion Share 1"],
  ["top_conversion_share_2", "Top Conversion Share 2"],
  ["top_conversion_share_3", "Top Conversion Share 3"],
  ["top_clicked_product_title_1", "Top Clicked Product Title 1"],
  ["top_clicked_product_title_2", "Top Clicked Product Title 2"],
  ["top_clicked_product_title_3", "Top Clicked Product Title 3"],
  ["reporting_date", "Reporting Date"],
];
